export default __webpack_public_path__ + "static/media/330_store05-es-web.271291e4.png";